import { render } from "./FormWishlist.vue?vue&type=template&id=cd207ec8"
import script from "./FormWishlist.vue?vue&type=script&lang=js"
export * from "./FormWishlist.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__